import React, { memo } from 'react';
import PropTypes from 'prop-types';

const CenteredYAxisLabel = (props) => {
  const { viewBox, children, ...rest } = props;
  const { x, y, height } = viewBox;
  const newX = x;
  const newY = y + height / 2;

  return (
    <text
      {...rest}
      x={newX}
      y={newY}
      transform={`rotate(-90, ${newX}, ${newY})`}
      className={`centered-y-axis-label ${rest.className || ''}`}
    >
      {children}
    </text>
  );
};

CenteredYAxisLabel.propTypes = {
  viewBox: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  children: PropTypes.node,
};

export default memo(CenteredYAxisLabel);
